// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.events/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.events/route.tsx");
}
// REMIX HMR END

import { eventListExample } from '@commural/shared-resources/schemas/business/Event.example';
import { useLoaderDataWithCache } from '@commural/shared-resources/utils/common';
import { Link } from '@remix-run/react';
import clsx from 'clsx';
import { DateTime } from 'luxon';
import invariant from 'tiny-invariant';
import { z } from 'zod';
import { ScrollView } from '~/components/ScrollView';
import { getCapitalized } from '~/utils.server';
import cn from './Events.module.css';
const TITLE = 'events';
const Tabs = ['open', 'past', 'draft'];
const TabsEnum = z.enum(Tabs);
_c = TabsEnum;
export async function loader({
  request,
  context,
  params
}) {
  const title = await getCapitalized(TITLE, request, context);
  const url = new URL(request.url);
  const result = TabsEnum.safeParse(url.searchParams.get('tab') ?? 'open');
  const tab = result.success ? result.data : 'open';
  return {
    title,
    tab,
    eventList: eventListExample
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  title: TITLE
};
export default function Index() {
  _s();
  const {
    tab,
    eventList
  } = useLoaderDataWithCache();
  return <ScrollView>
      <section className={cn.Events}>
        <header className={cn.Header}>
          <nav>
            <ul className={cn.Tabs}>
              {Tabs.map(el => <li key={el}>
                  <Link className={clsx({
                [cn.Active]: el === tab
              })} to={`?tab=${el}`} replace>

                    {el}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div>
            <button className="debug-block">filter</button>
            <button className="debug-block">create event</button>
          </div>
        </header>
        <main className={cn.Content}>
          {eventList.map(el => <EventDetail key={el.id} event={el} />)}
        </main>
      </section>
    </ScrollView>;
}
_s(Index, "CjnaakKOl47ry8kwvcJ2wu7yyew=", false, function () {
  return [useLoaderDataWithCache];
});
_c2 = Index;
function EventDetail({
  event
}) {
  return <div>
      <div>
        <p>{format(event.date)}</p>
        <p>
          {event.startTime}&ndash;{event.endTime}
        </p>
      </div>
      <h2>{event.name}</h2>
      <p>
        Attendees: {event.attendees}/{event.capacity}
      </p>
      <p>{event.description}</p>
    </div>;
}
_c3 = EventDetail;
function format(date) {
  return DateTime.fromISO(date, {
    setZone: true
  }).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
}
var _c, _c2, _c3;
$RefreshReg$(_c, "TabsEnum");
$RefreshReg$(_c2, "Index");
$RefreshReg$(_c3, "EventDetail");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;